import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const AuthorProfile = ({ author, compact = false }) => {
  if (compact) {
    return (
      <div className="flex items-center space-x-3">
        <Image
          src={author?.avatar}
          alt={author?.avatarAlt}
          className="w-10 h-10 rounded-full"
        />
        <div>
          <p className="font-medium text-sm">{author?.name}</p>
          <p className="text-xs text-muted-foreground">{author?.role}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-brand p-6">
      <div className="flex items-start space-x-4">
        <Image
          src={author?.avatar}
          alt={author?.avatarAlt}
          className="w-16 h-16 rounded-full"
        />
        
        <div className="flex-1">
          <h3 className="font-semibold text-lg">{author?.name}</h3>
          <p className="text-primary font-medium mb-2">{author?.role}</p>
          <p className="text-muted-foreground text-sm mb-4">{author?.bio}</p>
          
          <div className="flex items-center space-x-4 mb-4">
            <div className="flex items-center space-x-2 text-sm text-muted-foreground">
              <Icon name="FileText" size={16} />
              <span>{author?.articlesCount} articles</span>
            </div>
            <div className="flex items-center space-x-2 text-sm text-muted-foreground">
              <Icon name="Users" size={16} />
              <span>{author?.followers} followers</span>
            </div>
          </div>
          
          <div className="flex items-center space-x-2">
            {author?.socialLinks?.map((link) => (
              <Button
                key={link?.platform}
                variant="outline"
                size="icon"
                className="w-8 h-8"
              >
                <Icon name={link?.icon} size={16} />
              </Button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthorProfile;